import {fileRequest} from "@/utils/request";

//获取上传url
export function getUpurl(data) {
    return fileRequest({
        url: "/oss_client/api/pri/file/presignUpUrl",
        method: "post",
        data
    })
}

//上传成功回调
export function upBack(data) {
    return fileRequest({
        url: "/oss_client/api/pri/file/presignUpUrlBack",
        method: "post",
        data
    })
}

// oss 下载链接
export function getDownurl(data) {
    return fileRequest({
        url: "/oss_client/api/pri/file/presignDownUrl",
        method: "post",
        data
    })
}
